import React from 'react';
import { Text } from 'components/typography/Text';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { useModal } from 'store/modals';
import { useIntl } from 'react-intl';
import { useAccessManagement2NModal } from '../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import { discardChanges } from '../../../../discardChanges';
import styles from './styles.module.scss';

export const TimeProfile = ({ timeProfile }) => {

  const accessManagement2NModal = useAccessManagement2NModal();
  const selectedTimeProfile = accessManagement2NModal.selected.timeProfile;
  const timeProfileId = timeProfile && (timeProfile.Id || timeProfile.id);
  const selectedTimeProfileId = selectedTimeProfile && (selectedTimeProfile.Id || selectedTimeProfile.id);
  const timeProfileName = (timeProfile && (timeProfile.Name || timeProfile.name)) || '';
  const modal = useModal();
  const intl = useIntl();
  const onTimeProfileClick = () => discardChanges('timeProfile', timeProfile, intl, accessManagement2NModal, modal);

  return (
    <div
      className={styles.timeProfileCard}
      onClick={onTimeProfileClick}
    >
      <div className={styles.details}>
        {/*<div className={styles.icon}>*/}
        {/*  {group.icon}*/}
        {/*</div>*/}
        <Text
          size={14}
          uppercase
        >
          {timeProfileName}
        </Text>
      </div>

      <ShouldRender condition={!!selectedTimeProfile && selectedTimeProfileId === timeProfileId}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
};

